import DimShower from "./DimShower";
import SvgImageFilter from "./NewSvgImageFilter";
import { FigureChannelAdjustmentContext, TemporaryAdjustmentsContext, GridCellContext } from './Contexts';
import { v4 } from 'uuid';
import { useSelector } from 'react-redux';
import { computeFilterArgs } from './NewSvgImageFilter';
import G from './Getters';

import { useContext, useEffect, useRef, useState } from 'react';
import lodash from 'lodash';
import { useMemo } from 'react';
import svgToPng, { blobToBase64URL } from './svgToPngUsingImg';

function pointRotate([px, py], angle, [originX, originY]) {
    // Convert angle from degrees to radians
    const rad = angle * Math.PI / 180;

    // Translate point to origin
    const x = px - originX;
    const y = py - originY;

    // Apply rotation
    const xRot = x * Math.cos(rad) - y * Math.sin(rad);
    const yRot = x * Math.sin(rad) + y * Math.cos(rad);

    // Translate back
    const rx = xRot + originX;
    const ry = yRot + originY;

    return [rx, ry];
}

export default function MergedImages({
  toDraw,
  annotationId,
  width: widthProp,
  height: heightProp,
  crop: cropProp,
  imageUrlMap,
  dbgMsg,
  imageInfo,
  parentComp,
}){


  if( !imageInfo ){

    let comp = parentComp;

    let err = new Error();
    console.log(err);
    debugger;
  }


  let crop = cropProp;
  if (dbgMsg == null) dbgMsg = () => {};
  const compIdRef = useRef(v4());
  const compId = compIdRef.current;

  const svgRef = useRef(null);
  const { channels, adjustment: adjustmentC, setAdjustment } = useContext(FigureChannelAdjustmentContext);
  const cellLocation = useContext(GridCellContext);
  
  const { temporaryAdjustments, interactive: parentIsCropEditor } = useContext(TemporaryAdjustmentsContext) ?? {};
  const state = useSelector(state => state);
  

  const [dims, _setDims] = useState((widthProp && heightProp) ? {width:widthProp,height:heightProp} : null);

  /*
  if( !dims ){
    debugger;
  }
  */


  function setDims(arg){
    //debugger;
    if( !widthProp ){
      _setDims(arg);
    }
  }

  //console.log(crop.annotationId,"OUTER DIMS:",dims);

  useEffect(() => {
    const observeTarget = svgRef.current;


    const resizeObserver = new ResizeObserver((entries) => {
      requestAnimationFrame(() => {
        for (let entry of entries) {
          //const { width, height } = entry.contentRect;
          const { width, height } = observeTarget.getBoundingClientRect();
          
          if( width !== 0 && height !== 0 && (JSON.stringify({width,height})!==JSON.stringify(dims))){

            setDims({ width, height });
          }
        }
      });
    });


    if (observeTarget) {
      resizeObserver.observe(observeTarget);
    }

    return () => {
      if (observeTarget) {
        resizeObserver.unobserve(observeTarget);
      }
      resizeObserver.disconnect();
    };
  }, []);


  // restore stored per-channel adjustments
  useEffect(() => {
    if (setAdjustment != null) {
      const updateEntries = toDraw.filter(info => info.imageId).map(info => {
        const { imageId, channelId } = info;
        let { adjustments } = G.getImage(state,imageId);
        return [channelId, { 
          ...(adjustmentC?.[channelId]),
          ...adjustments,
        }]
      });
      setAdjustment({
        ...adjustmentC,
        ...Object.fromEntries(updateEntries)
      });
    }
  }, []);

  

  

  const pixelDims = imageInfo?.[0]?.pixelDims ?? null;
  const origAspectRatio = pixelDims == null ? 1 : pixelDims.height / pixelDims.width;

  // Use an image instead of filters during export
  let exportIm = undefined;
  if (imageUrlMap?.[compId] != null) {
    let url = imageUrlMap[compId];
    exportIm = <image xlinkHref={url} href={url} x={0} y={0} width={'100%'} height={'100%'} />;
  }

  
  if (temporaryAdjustments !== undefined) {
    // this is in the 'crop preview' area; disable crop and bounds
    if (parentIsCropEditor) {
      crop = {};
    }
    // (the wrong bounds are passed in here)
    widthProp = undefined;
    heightProp = undefined;
  }
  if (crop == null) {
    let firstCrop = imageInfo?.[0]?.inlineCrop;
    if (firstCrop != null) {
      let allEq = true;
      for(const info of imageInfo) {
        if (!lodash.isEqual(info.inlineCrop, firstCrop)) {
          allEq = false;
          break;
        }
      }
      if (allEq) {
        crop = firstCrop;
      }
    }
  }
  if (crop != null) {
    let defaultCrop = {
      left: 0,
      top: 0,
      width: 1,
      height: dims != null ? dims.height/dims.width : 1,
      zoom: 1,
      deltaX: 0,
      deltaY: 0,
      rotation: 0
    };
    crop = { ...defaultCrop, ...crop };
  }

  let imageKey = "";
  let infoSignature = "";
  imageInfo?.forEach(({color,imageId,adjustments},ii) => {
    imageKey += ((ii > 0 ? ",":"") + imageId)
    infoSignature += ((ii>0?",":"") + JSON.stringify({color,...adjustments}))
  })
  imageKey += infoSignature;


  let { filterId, filter } = useMemo(() => {
    if( !imageInfo ){
      debugger;
    }
    let argsToComputeOn = Object.values(imageInfo).map(val => ({
      colorProjection: val.color,
      imgurl: val.url,
      ...val.adjustments,
    }));
    const computedFilterArgs = computeFilterArgs(argsToComputeOn);
    let filterId = v4();
    return { 
      filterId, 
      filter: <SvgImageFilter {...{ filterArgsList:computedFilterArgs,filterName:filterId }}/> }
  },[imageInfo])

  let width = widthProp ?? dims?.width;
  let height = heightProp ?? dims?.height;
  //const width = dims?.width;
  //const height = dims?.height;

  // Top-left of crop 'viewbox'
  let viewX = 0;
  let viewY = 0;
  // Width/height of crop 'viewbox' on the un`transform`ed image
  let viewWidth = 1;
  let viewHeight = 1;
  // The desired width and height of the image after cropping (in its container)
  let desiredWidth = '100%';
  let desiredHeight = '100%';
  let viewScale = 1;
  let transform = "";
  let clipX = 0;
  let clipY = 0;

  // Dimensions before any transformations are applied
  let beforeDims = { ...dims };
  // TODO test
  
  if (crop != null && width != null && height != null) {
    // if the aspect ratio of the container isn't the same as
    // the aspect ratio of the crop,
    // then as the crop grows in the container,
    // one of the sides will hit the border before the other
    // this is the 'bottleneck' side
    let layoutAspectRatio = height/width;
    let cropAspectRatio = crop.height/crop.width;
    // first, the original picture displayed will be forced to fit in the center
    if (layoutAspectRatio > origAspectRatio) {
      // width is the bottleneck
      beforeDims = { width, height: origAspectRatio*width };
    } else {
      // height is the bottleneck
      beforeDims = { height, width: height/origAspectRatio };
    }
    viewWidth = crop.width*beforeDims.width;
    viewHeight = crop.height*beforeDims.width;
    // next, compute the dims of the crop inside
    // keep in mind that crop.{width, height} are in 'width units':
    // that is, 1 width unit = 1 full image width
    //if (layoutAspectRatio > cropAspectRatio) {
    // HACK to compensate for the aspect ratio padding issue,
    // the above if statement is compensated with some error to prefer the longer dimension
    // if the grid cell is trying to fit it
    let widthBottleneck = layoutAspectRatio > cropAspectRatio;
    const THRESH = 3;
    const RATIO_DIFF_THRESH = 100; // 0.05
    if (cropAspectRatio > THRESH) {
      // Large height relative to width
      let ratioDiff = Math.abs(1/layoutAspectRatio - 1/cropAspectRatio);
      if (ratioDiff < RATIO_DIFF_THRESH) {
        widthBottleneck = false;
      }
    } else if (cropAspectRatio < 1/THRESH) {
      // Large width relative to height
      let ratioDiff = Math.abs(layoutAspectRatio - cropAspectRatio);
      if (ratioDiff < RATIO_DIFF_THRESH) {
        widthBottleneck = true;
      }
    }

    if (widthBottleneck) {
      // width is the bottleneck
      dbgMsg('width bottleneck');
      desiredWidth = width;
      desiredHeight = cropAspectRatio*width;
      // we want to scale so that the crop's width is the same as the image width
      viewScale = desiredWidth/viewWidth;
    } else {
      // height is the bottleneck
      dbgMsg('height bottleneck');
      desiredWidth = height/cropAspectRatio;
      desiredHeight = height;
      // we want to scale so that the crop's height is the same as the image height
      viewScale = desiredHeight/viewHeight;
    }

    viewX = (crop.left * beforeDims.width);
    viewY = crop.top * beforeDims.width;
    const { zoom, deltaX, deltaY } = crop;

    if( zoom > 1 ){
    debugger;
    }

  
    let angle = crop.rotation;
    let rotationOriginX = zoom * width /2;
    let rotationOriginY = zoom * height /2;
    let rotate = `rotate(${-angle}, ${rotationOriginX}, ${rotationOriginY})`;
    let heightPad = (height - beforeDims.height)/2;
    let widthPad = (width - beforeDims.width)/2;
    viewY += heightPad;
    viewX += widthPad;
    clipX = viewX;
    clipY = viewY;
    // Center it in the cell
    //let beforeCropWidth = cropWidth/cropScale;
    //let beforeCropHeight = cropHeight/cropScale;
    //cropX -= (width - cropWidth)/(2*cropScale);
    //cropY -= (height - cropHeight)/(2*cropScale);
    let translate = "translate("+(-viewX)+","+(-viewY)+")";
    let scale = `scale(${viewScale})`;

    transform = '';
    transform = rotate;
    transform = translate + " " + rotate;
    // Transforms are in RTL order
    transform = `${scale} ${translate} ${rotate}`;

    // Transform clip{X,Y} for post-transform
    [clipX, clipY] = pointRotate([clipX, clipY], -angle, [rotationOriginX, rotationOriginY]);
    clipX += viewX;
    clipY += viewY;
    clipX /= viewScale;
    clipY /= viewScale;
  }


  clipX = 0; clipY = 0;
  let clipPathId = v4();

  console.log(crop.annotationId,"filterId",filterId);


  return exportIm ?? (
    <>

      
    <svg style={{

      //transform:'scaleX(-1)',

      //width:widthProp,
      //border:'3px solid cyan',
      verticalAlign: 'baseline' // override 
    }} class="full-dim merged-image" 
      colorInterpolationFilters={"sRGB"} 
        xmlns="http://www.w3.org/2000/svg" 
      ref={svgRef}
        preserveAspectRatio="xMinYMin slice"
        data-compId={compId}
        data-pixelDims={JSON.stringify(pixelDims)}
    >
      
      
      
      <defs>
        {filter}
        <clipPath id={clipPathId}>
          {/* This applies *after* the transform,
            where the (0,0) point is the top-left of the crop,
            and the crop is already scaled to meet the container dimensions.
            Therefore we only need to restrict by scaled width/height. */}
          <rect x={clipX} y={clipY} width={desiredWidth} height={desiredHeight} />
        </clipPath>
      </defs>
      <g 
        clipPath={`url(#${clipPathId})`}
      >
        <rect x="0" y="0" width={'100%'} height={'100%'} filter={`url(#${filterId})`} transform={transform} />
      </g>

    </svg>

    </>
  )


}
